const baseURL = 'https://admin.gdlqlawyer.com/apis/';

// 导出服务器基础URL（去掉apis路径）
export const serverBaseUrl = baseURL.replace('/apis/', '');

export function request(path, options = {}) {
  return fetch(baseURL + path, options)
    .then(res => res.json());
} 